import styled, { css } from 'styled-components'
import { TitleStyle } from 'Components/Shared/Title/TitleStyle'

export const PCWPageStyle = styled.div<{
  blur?: boolean
  blurDuration?: number
}>`
  display: flex;
  flex-direction: column;

  ${(props) => `
    transition: all ${props.blurDuration || 0}s ease-in-out;
  `}

  ${(props) =>
    props.blur &&
    css`
      filter: blur(2px) saturate(0.8);
    `};
`
export const HeaderStyle = styled.div`
  font-family: AIAEverest-Regular, Helvetica, sans-serif;
`

export const FooterStyle = styled.p`
  font-size: ${(props) => props.theme.footer?.fontSize || 1}em;
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: right;
  padding: 2em 0em 2em 2em;
  font-size: normal;
`
export const HeaderWrapper = styled.div`
  padding-left: 20px;
  width: 103.5%;
  background: rgb(158, 224, 148);
  ${TitleStyle} {
    padding-right: 1em;
  }
`
export const ContentStyle = styled.div`
  width: min-content;
  margin: auto;
`

export const TableHeaders = styled.div`
  display: flex;
  flex-direction: row;
`
export const Headers = styled.div`
  display: flex;
  padding-bottom: 1em;
  @media (max-width: 600px) {
    display: none;
  }
  flex-direction: row;
  font-weight: bold;
  .headerCell {
    width: 120px;
    text-align: center;
  }
`
